import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestore, AngularFirestoreModule } from '@angular/fire/firestore';
import { TranslateLoader, TranslateModule as NgxTranslateModule } from '@ngx-translate/core';

import { TranslateFactory } from './factories';

export const TranslateLoaderModule = (environment) => {
    @NgModule({
        imports: [
            AngularFirestoreModule,

            AngularFireModule.initializeApp(environment.firebase),
            NgxTranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: TranslateFactory,
                    deps: [
                        AngularFirestore,
                    ],
                },
            }),
        ],
        exports: [
            NgxTranslateModule,
        ],
    })

    class LoaderModule {}

    return new LoaderModule() as any;
};
